import React from "react";
import "./Contact.css";

function Contact(props) {
  return (
    <div className="Contact">
      <a href="mailto:austin@ayy.fish" target="_blank">
        <i className="fa fa-envelope fa-lg fa-fw" />
      </a>
      <a href="https://twitter.com/ayyfishh" target="_blank">
        <i className="fa fa-twitter fa-lg fa-fw" />
      </a>
      <a href="https://instagram.com/ayyfish" target="_blank">
        <i className="fa fa-instagram fa-lg fa-fw" />
      </a>
      <a
        href="https://www.youtube.com/channel/UCrwHa9UxX7R2aaVY2uhlrBw"
        target="_blank"
      >
        <i className="fa fa-youtube-play fa-lg fa-fw" />
      </a>
      <a href="https://linkedin.com/in/ayyfish" target="_blank">
        <i className="fa fa-linkedin fa-lg fa-fw" />
      </a>
      <a href="https://github.com/ayyfish" target="_blank">
        <i className="fa fa-github fa-lg fa-fw" />
      </a>
    </div>
  );
}

export default Contact;



// WEBPACK FOOTER //
// ./src/components/Contact/Contact.js